export default(str=>{const r=str.replace(/([A-Z])/g,"_$1").replace(/[_\s]+/g," ").trim().toLowerCase();return r.charAt(0).toUpperCase()+r.slice(1)});